import axios from "axios";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
import { Description } from '@mui/icons-material';

export interface CommunityItem {
  id: string;
  title: string;
  images?: any;
  detail_image?: any;
  short_description?: string;
  description?: string;
  buttonText?: string;
  status?:boolean;
  path?:any;
}

export const getCommunityDevelopmentList = async (): Promise<CommunityItem[]> => {
  const url = `${API_BASE_CMS}/jsonapi/node/community_development_detail_pag?include=field_community_detail_image.field_media_image,field_community_image.field_media_image`;
  
  const { data } = await axios.get(url);
  const included = data.included || [];

  const getImageFromMedia = (mediaId?: string) => {
   if (!mediaId) return { url: null, alt: null };
 
   const media = included?.find(
     (inc: any) => inc.type === "media--image" && inc.id === mediaId
   );
 
   const fileId =
     media?.relationships?.field_media_image?.data?.id;
 
   const altText =
     media?.relationships?.field_media_image?.data?.meta?.alt ||
     media?.attributes?.name ||
     "";
 
   const file = included?.find(
     (inc: any) => inc.type === "file--file" && inc.id === fileId
   );
 
   const fileUrl = file?.attributes?.uri?.url
     ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
     : null;
 
   return {
     url: fileUrl,
     alt: altText,
   };
 };

  return data.data.map((node: any) => {
        const Image = node.relationships.field_community_image?.data?.id;
         const detailImage = node.relationships.field_community_detail_image?.data?.id;
    return {
      id: node.id,
      title: node.attributes.title,
      status: node.attributes.status,
      path: node.attributes.path.alias,
      images: getImageFromMedia(Image),
      detail_image: getImageFromMedia(detailImage),
      short_description: node.attributes.field_short_description?.value || "",
      description: node.attributes.field_content?.value || "",
      page_display: node.attributes.field_pages_display || "",
      buttonText: node.attributes.field_button_name || "Read More",
    };
  });
};

//Community Velow banner content
export interface CommunityPageContent {
  id: string;
  bannertitle:string;
  title:string;
  subtitle:string;
  smalltitle:string;
  description:string;
  backbutton:string;
  images:any;
}

export const getCommunityPageContent = async (): Promise<CommunityPageContent | null> => {
  try {
    const url = `${API_BASE_CMS}/jsonapi/node/community_development_page`;
    const { data } = await axios.get(url);

    if (!data.data || data.data.length === 0) return null;

    const pageNode = data.data[0]; // take the first node
    return {
      id: pageNode.id,
      bannertitle:pageNode.attributes.title || "",
      title:pageNode.attributes.field_main_title || "",
      subtitle:pageNode.attributes.field_title || "",
      smalltitle:pageNode.attributes.field_small_title || "",
      description:pageNode.attributes.field_community_content || "",
      backbutton:pageNode.attributes.field_media_back_button || "",
      images:pageNode.attributes.field_community_content || ""
    };
  } catch (error) {
    console.error("Error fetching community page content:", error);
    return null;
  }
};